<template>
  <div class="usage-box">
    <NvHeader :title="title" />
    <div class="content-box">
      <template v-if="list.length > 0">
        <NvHistoryItem v-for="(item, index) in list" :key="index" :type="type" :item="item" />
      </template>
      <NvEmpty v-else />
    </div>
  </div>
</template>

<script>
import NvEmpty from "@/components/widget/NvEmpty";
import NvHeader from "@/components/widget/NvHeader";
import NvHistoryItem from "@/components/widget/my/NvHistoryItem";
import { getConsumeOrders, getCoinsRecord } from "@/service/api";
const titleMap = {
  deposit: "Deposit History",
  usage: "Usage History"
};

const nameMap = {
  deposit: "Deposit_History_Page_Show",
  usage: "Usage_History_Page_Show"
};

export default {
  components: {
    NvEmpty,
    NvHeader,
    NvHistoryItem
  },
  data() {
    return {
      list: [],
      type: "",
      title: ""
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getList() {
      this.getListFn().then(res => {
        this.list = res;
      });
    },
    getListFn() {
      if (this.type === "deposit") {
        return getConsumeOrders();
      } else if (this.type === "usage") {
        return getCoinsRecord();
      } else {
        return Promise.resolve([]);
      }
    }
  },
  mounted() {
    const type = this.$route.query.type;
    this.type = type;
    this.title = titleMap[type];
    window.$event(nameMap[type], {});
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.usage-box {
  .content-box {
    margin-top: 45px;
  }
}
</style>
